import { paginationFactory } from 'factories/pagination';
import { ScoreReport, StoreRevokedDetails, StoreScoreDay } from 'types';
import { convertTimestampToDate } from 'helpers';

function populateRevokedDetails(revokedDetails: any = {}): StoreRevokedDetails {
  const { deadlineExceeded, others, priceDivergence, stockDivergence } =
    revokedDetails;

  return {
    deadlineExceeded: deadlineExceeded || 0,
    others: others || 0,
    priceDivergence: priceDivergence || 0,
    stockDivergence: stockDivergence || 0,
  };
}

function populateResults(results: any[] = []): StoreScoreDay[] {
  return results.map((result) => {
    const {
      confirmed,
      confirmedPercentage,
      consignments,
      date,
      revoked,
      revokedDetails,
      priority,
    } = result;

    return {
      confirmed: confirmed || 0,
      confirmedPercentage: confirmedPercentage || 0,
      consignments: consignments || 0,
      date: convertTimestampToDate(date || 0),
      revoked: revoked || 0,
      priority: priority || 0,
      revokedDetails: populateRevokedDetails(revokedDetails),
    };
  });
}

export function scoreReportFactory(data: any = {}): ScoreReport {
  const { pagination, results } = data;

  return {
    pagination: paginationFactory(pagination),
    results: populateResults(results),
  };
}
